import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import FullScreenDialog from '../../../common/FullScreenDialog';
import {useGetLocationListQuery} from "../../../../api/locations/locationsApiSlice";
import {setUseCaseLocations} from "../../../../redux/slice/booking/bookingSlice";
import {useDispatch} from "react-redux";
import GiftVoucherPage from '../pages/GiftVoucherPage';

interface BookLocationDialogProps {
    open: boolean;
    locationId?: string;
}


const VoucherPurchaseDialog = (props: BookLocationDialogProps) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    // Note: It's currently important that BookLocationPage is only mounted when location is available
    // due to body scroll locking

    const { data: locations } = useGetLocationListQuery("rental");

    useEffect(() => {
        if (locations) {
            dispatch(setUseCaseLocations(locations));
        }
    }, [locations, dispatch]);

    return (
        <FullScreenDialog open={props.open} ariaLabel={t("common.dialog.voucher")}>
            <GiftVoucherPage />
        </FullScreenDialog>
    );
};

export { VoucherPurchaseDialog };
